module.exports = __webpack_public_path__ + "img/token-icon.04927c44.svg";